import { formatShortDate } from "@shared";

const PERIOD_SEPARATOR = " – ";

/** "01.07.2027 – 31.12.2027" */
export function formatPeriod(periodStart: Date, periodEnd: Date): string {
  return `${formatShortDate(periodStart)}${PERIOD_SEPARATOR}${formatShortDate(periodEnd)}`;
}
